/**
 * jewelry-builder.js
 * Configurateur de bijoux en 3 étapes (corde -> maillon -> charm) + résumé.
 * Vanilla JS, sans dépendance externe. Compatible Shopify Online Store 2.0.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jb-config-state-v1';
  var STEP_ORDER = ['cord', 'connector', 'charm', 'summary'];
  var MAX_CHARMS = 4;

  function init(root) {
    var sectionId = root.getAttribute('data-section-id');
    var configEl = document.querySelector('script[data-jb-config="' + sectionId + '"]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[jewelry-builder] Configuration JSON invalide', e);
      return;
    }

    new JewelryBuilder(root, config);
  }

  function JewelryBuilder(root, config) {
    this.root = root;
    this.config = config;

    // ---- Mode presse (?mode=press&code=PRESS_PRENOM_001) ----
    var params = new URLSearchParams(window.location.search);
    this.pressMode = params.get('mode') === 'press';
    this.pressCode = (params.get('code') || '').trim();
    this.pressModeBlocked = this.pressMode && !this.pressCode;
    // En mode presse valide : 1 charm max (et obligatoire). Sinon : comportement normal (jusqu'à 4, facultatif).
    this.maxCharms = (this.pressMode && !this.pressModeBlocked) ? 1 : MAX_CHARMS;

    this.state = {
      cord: null,
      connector: null,
      charm: []
    };
    this.currentStepIndex = 0;
    this.charmFilters = { search: '', finish: 'all' };
    this.cordFilter = 'all';

    this.cacheDom();

    if (this.pressModeBlocked) {
      this.showPressBlocked();
      return;
    }

    if (this.pressMode) {
      this.showPressBanner();
      this.applyPressModeText();
    }

    this.restoreFromSession();
    this.bindEvents();
    this.renderAllGrids();
    this.updateAllUI();
  }

  JewelryBuilder.prototype.cacheDom = function () {
    this.el = {
      steps: this.root.querySelectorAll('[data-step]'),
      progressSteps: this.root.querySelectorAll('[data-progress-step]'),
      stepCaption: this.root.querySelector('[data-step-caption]'),
      announcer: this.root.querySelector('[data-jb-announcer]'),
      grids: {
        cord: this.root.querySelector('[data-jb-grid="cord"]'),
        connector: this.root.querySelector('[data-jb-grid="connector"]'),
        charm: this.root.querySelector('[data-jb-grid="charm"]')
      },
      nextButtons: this.root.querySelectorAll('[data-jb-next]'),
      backButtons: this.root.querySelectorAll('[data-jb-back]'),
      cordTabs: this.root.querySelectorAll('[data-cord-filter]'),
      charmSearch: this.root.querySelector('[data-jb-charm-search]'),
      charmCount: this.root.querySelector('[data-jb-charm-count]'),
      step3HintText: this.root.querySelector('[data-jb-step3-hint-text]'),
      pressBanner: this.root.querySelector('[data-jb-press-banner]'),
      pressBlocked: this.root.querySelector('[data-jb-press-blocked]'),
      charmFinishFilters: this.root.querySelectorAll('[data-charm-finish]'),
      summary: this.root.querySelector('[data-jb-summary]'),
      addToCartBtn: this.root.querySelector('[data-jb-add-to-cart]'),
      toast: this.root.querySelector('[data-jb-toast]'),
      stickyBar: this.root.querySelector('[data-jb-sticky-bar]'),
      stickyNext: this.root.querySelector('[data-jb-sticky-next]'),
      stickyBack: this.root.querySelector('[data-jb-sticky-back]')
    };
  };

  /* -------------------- Mode presse -------------------- */

  JewelryBuilder.prototype.showPressBlocked = function () {
    if (this.el.pressBlocked) this.el.pressBlocked.hidden = false;
    this.el.steps.forEach(function (stepEl) { stepEl.style.display = 'none'; });
    if (this.el.stickyBar) this.el.stickyBar.style.display = 'none';
  };

  JewelryBuilder.prototype.showPressBanner = function () {
    if (this.el.pressBanner) this.el.pressBanner.hidden = false;
  };

  JewelryBuilder.prototype.applyPressModeText = function () {
    if (this.el.step3HintText) {
      this.el.step3HintText.textContent = this.config.i18n.pressStep3Hint;
    }
  };

  JewelryBuilder.prototype.bindEvents = function () {
    var self = this;

    this.el.nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        if (btn.getAttribute('data-jb-next') === 'charm') {
          self.goToStep(3);
        } else {
          self.goToStep(self.currentStepIndex + 1);
        }
      });
    });

    this.el.backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.goToStep(self.currentStepIndex - 1);
      });
    });

    this.el.stickyNext.addEventListener('click', function () {
      if (self.el.stickyNext.hasAttribute('disabled')) return;
      self.goToStep(self.currentStepIndex + 1);
    });
    this.el.stickyBack.addEventListener('click', function () {
      self.goToStep(self.currentStepIndex - 1);
    });

    this.el.cordTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.el.cordTabs.forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
        tab.setAttribute('aria-pressed', 'true');
        self.cordFilter = tab.getAttribute('data-cord-filter');
        self.renderGrid('cord');
      });
    });

    if (this.el.charmSearch) {
      this.el.charmSearch.addEventListener('input', function () {
        self.charmFilters.search = this.value.trim().toLowerCase();
        self.renderGrid('charm');
      });
    }

    this.el.charmFinishFilters.forEach(function (chip) {
      chip.addEventListener('click', function () {
        self.el.charmFinishFilters.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        self.charmFilters.finish = chip.getAttribute('data-charm-finish');
        self.renderGrid('charm');
      });
    });

    this.el.addToCartBtn.addEventListener('click', function () {
      self.addToCart();
    });

    // Délégation d'édition depuis le résumé
    this.el.summary.addEventListener('click', function (evt) {
      var editBtn = evt.target.closest('[data-jb-edit]');
      if (!editBtn) return;
      var target = editBtn.getAttribute('data-jb-edit');
      self.goToStep(STEP_ORDER.indexOf(target));
    });
  };

  /* -------------------- Rendu des grilles -------------------- */

  JewelryBuilder.prototype.renderAllGrids = function () {
    this.renderGrid('cord');
    this.renderGrid('connector');
    this.renderGrid('charm');
  };

  JewelryBuilder.prototype.getItemsForType = function (type) {
    if (type === 'cord') return this.config.cordVariants || [];
    if (type === 'connector') return this.config.connectors || [];
    if (type === 'charm') return this.sortCharms(this.config.charms || []);
    return [];
  };

  JewelryBuilder.prototype.sortCharms = function (items) {
    var mode = this.config.charmSortMode || 'manual';
    var withIndex = items.map(function (item, i) { return { item: item, i: i }; });

    if (mode === 'newest') {
      withIndex.sort(function (a, b) {
        var da = a.item.createdAt ? new Date(a.item.createdAt).getTime() : 0;
        var db = b.item.createdAt ? new Date(b.item.createdAt).getTime() : 0;
        if (db !== da) return db - da;
        return a.i - b.i;
      });
    } else if (mode === 'bestseller') {
      withIndex.sort(function (a, b) {
        var ba = a.item.bestseller ? 1 : 0;
        var bb = b.item.bestseller ? 1 : 0;
        if (bb !== ba) return bb - ba;
        return a.i - b.i;
      });
    } else {
      // Manuel : les charms avec une position renseignée passent en premier
      // (triés par position croissante), les autres gardent l'ordre des slots.
      withIndex.sort(function (a, b) {
        var pa = (a.item.position === null || a.item.position === undefined) ? null : a.item.position;
        var pb = (b.item.position === null || b.item.position === undefined) ? null : b.item.position;
        if (pa !== null && pb !== null) return (pa - pb) || (a.i - b.i);
        if (pa !== null) return -1;
        if (pb !== null) return 1;
        return a.i - b.i;
      });
    }

    return withIndex.map(function (w) { return w.item; });
  };

  JewelryBuilder.prototype.filterItems = function (type, items) {
    var self = this;
    if (type === 'cord' && this.cordFilter !== 'all') {
      items = items.filter(function (item) { return item.productType === self.cordFilter; });
    }
    if (type === 'charm') {
      if (this.charmFilters.finish !== 'all') {
        items = items.filter(function (item) { return item.finish === self.charmFilters.finish; });
      }
      if (this.charmFilters.search) {
        items = items.filter(function (item) {
          return item.title.toLowerCase().indexOf(self.charmFilters.search) !== -1;
        });
      }
    }
    return items;
  };

  JewelryBuilder.prototype.renderGrid = function (type) {
    var grid = this.el.grids[type];
    if (!grid) return;
    var items = this.filterItems(type, this.getItemsForType(type));
    var self = this;
    var selected = this.state[type];

    grid.innerHTML = '';

    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'jb-empty-state';
      empty.textContent = this.config.i18n.emptyState;
      grid.appendChild(empty);
      return;
    }

    items.forEach(function (item) {
      grid.appendChild(self.buildCard(type, item, selected));
    });
  };

  JewelryBuilder.prototype.buildCard = function (type, item, selected) {
    var self = this;
    var isSelected = type === 'charm'
      ? selected.some(function (i) { return i.variantId === item.variantId; })
      : (!!selected && selected.variantId === item.variantId);
    var isAvailable = !!item.available;

    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'jb-card' + (isAvailable ? '' : ' jb-card--unavailable');
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    card.setAttribute('data-variant-id', item.variantId);
    if (!isAvailable) {
      card.disabled = true;
      card.setAttribute('aria-disabled', 'true');
    }

    var imageWrap = document.createElement('span');
    imageWrap.className = 'jb-card__image-wrap';

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'jb-card__image';
      img.src = item.image;
      img.loading = 'lazy';
      img.alt = item.title || '';
      img.width = 400;
      img.height = 400;
      imageWrap.appendChild(img);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'jb-card__image-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      imageWrap.appendChild(placeholder);
    }

    if (!isAvailable) {
      var badge = document.createElement('span');
      badge.className = 'jb-card__badge jb-card__badge--oos';
      badge.textContent = this.config.i18n.cardOutOfStock;
      imageWrap.appendChild(badge);
    }

    var check = document.createElement('span');
    check.className = 'jb-card__check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M6 10.5L8.5 13L14 7" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    imageWrap.appendChild(check);

    var body = document.createElement('span');
    body.className = 'jb-card__body';

    var subtitleText = type === 'cord' ? item.productType : item.finish;
    if (subtitleText) {
      var subtitle = document.createElement('span');
      subtitle.className = 'jb-card__subtitle';
      subtitle.textContent = subtitleText;
      body.appendChild(subtitle);
    }

    var title = document.createElement('span');
    title.className = 'jb-card__title';
    title.textContent = type === 'cord' ? item.colorName : item.title;
    body.appendChild(title);

    var price = document.createElement('span');
    price.className = 'jb-card__price';
    if (type === 'cord') {
      price.innerHTML = '<s>' + this.formatMoney(item.price) + '</s> <span class="jb-card__free-label">' + this.config.i18n.cardFreeLabel + '</span>';
    } else {
      price.textContent = this.formatMoney(item.price);
    }
    body.appendChild(price);

    var selectedLabel = document.createElement('span');
    selectedLabel.className = 'jb-card__selected-label';
    selectedLabel.textContent = this.config.i18n.cardSelectedLabel;
    body.appendChild(selectedLabel);

    card.appendChild(imageWrap);
    card.appendChild(body);

    if (isAvailable) {
      card.addEventListener('click', function () {
        self.selectItem(type, item);
      });
    }

    return card;
  };

  JewelryBuilder.prototype.selectItem = function (type, item) {
    var name = item.title || item.colorName;
    if (type === 'charm') {
      var idx = this.state.charm.findIndex(function (i) { return i.variantId === item.variantId; });
      if (idx !== -1) {
        this.state.charm.splice(idx, 1);
        this.announce(this.config.i18n.announceRemoved.replace('%name%', name));
      } else if (this.pressMode) {
        // Mode presse : sélection unique, remplace automatiquement le charm précédent.
        this.state.charm = [item];
        this.announce(this.config.i18n.announceSelected.replace('%name%', name));
      } else {
        if (this.state.charm.length >= this.maxCharms) {
          this.showToast(this.config.i18n.charmLimitReached, true);
          return;
        }
        this.state.charm.push(item);
        this.announce(this.config.i18n.announceSelected.replace('%name%', name));
      }
    } else {
      this.state[type] = item;
      this.announce(this.config.i18n.announceSelected.replace('%name%', name));
    }
    this.renderGrid(type);
    this.updateAllUI();
    this.persistToSession();
  };

  /* -------------------- Navigation -------------------- */

  JewelryBuilder.prototype.goToStep = function (index) {
    if (index < 0 || index > STEP_ORDER.length - 1) return;
    // Empêche d'avancer si l'étape courante n'est pas complète.
    // L'étape charm est facultative en mode normal, obligatoire en mode presse.
    if (index > this.currentStepIndex) {
      var currentType = STEP_ORDER[this.currentStepIndex];
      if (currentType === 'charm') {
        if (this.pressMode && this.state.charm.length === 0) return;
      } else if (currentType !== 'summary' && !this.state[currentType]) {
        return;
      }
    }

    this.currentStepIndex = index;
    this.updateAllUI();

    if (STEP_ORDER[index] === 'summary') {
      this.renderSummary();
    }

    window.scrollTo({ top: this.root.offsetTop - 20, behavior: 'smooth' });
  };

  JewelryBuilder.prototype.updateAllUI = function () {
    var self = this;

    this.el.steps.forEach(function (stepEl) {
      var stepName = stepEl.getAttribute('data-step');
      var isActive = STEP_ORDER[self.currentStepIndex] === stepName;
      stepEl.setAttribute('data-active', isActive ? 'true' : 'false');
    });

    this.el.progressSteps.forEach(function (progEl, i) {
      var state = 'upcoming';
      if (i < self.currentStepIndex) state = 'done';
      if (i === self.currentStepIndex) state = 'active';
      progEl.setAttribute('data-state', state);
    });

    if (this.el.stepCaption) {
      this.el.stepCaption.textContent = this.config.i18n.stepCaption
        .replace('%step%', this.currentStepIndex + 1)
        .replace('%total%', STEP_ORDER.length);
    }

    this.el.nextButtons.forEach(function (btn) {
      var type = btn.getAttribute('data-jb-next');
      var val = self.state[type];
      btn.disabled = type === 'charm' ? (self.pressMode ? val.length === 0 : false) : !val;
    });

    if (this.el.charmCount) {
      this.el.charmCount.textContent = this.config.i18n.charmCountLabel
        .replace('%count%', this.state.charm.length)
        .replace('%max%', this.maxCharms)
        .replace('%plural%', this.state.charm.length > 1 ? 's' : '');
    }

    var nextType = STEP_ORDER[this.currentStepIndex];
    if (this.el.stickyNext) {
      if (nextType === 'summary') {
        this.el.stickyBar.style.display = 'none';
      } else {
        this.el.stickyBar.style.display = '';
        var nextVal = this.state[nextType];
        this.el.stickyNext.disabled = nextType === 'charm' ? (this.pressMode ? nextVal.length === 0 : false) : !nextVal;
        this.el.stickyNext.textContent = nextType === 'charm' ? this.config.i18n.stickyNextCharm : this.config.i18n.stickyNextDefault;
      }
    }
    if (this.el.stickyBack) {
      this.el.stickyBack.style.visibility = this.currentStepIndex === 0 ? 'hidden' : 'visible';
    }
  };

  /* -------------------- Résumé -------------------- */

  JewelryBuilder.prototype.buildSummaryRowHtml = function (kicker, item, name, editKey, isFree) {
    var priceHtml = isFree
      ? '<s>' + this.formatMoney(item.price) + '</s> <strong class="jb-summary__free-label">' + this.config.i18n.cardFreeLabel + '</strong>'
      : this.formatMoney(item.price);
    return '' +
      '<div class="jb-summary__row">' +
        (item.image ? '<img class="jb-summary__thumb" src="' + item.image + '" alt="" loading="lazy">' : '<span class="jb-summary__thumb" aria-hidden="true"></span>') +
        '<div class="jb-summary__info">' +
          '<p class="jb-summary__kicker">' + kicker + '</p>' +
          '<p class="jb-summary__name">' + this.escapeHtml(name) + '</p>' +
          '<p class="jb-summary__price">' + priceHtml + '</p>' +
        '</div>' +
        '<button type="button" class="jb-summary__edit" data-jb-edit="' + editKey + '">' + this.config.i18n.summaryEditButton + '</button>' +
      '</div>';
  };

  JewelryBuilder.prototype.renderSummary = function () {
    var self = this;
    var singleRows = [
      { key: 'cord', kicker: this.config.i18n.summaryKickerCord, item: this.state.cord, nameFn: function (i) { return i.productType + ' — ' + i.colorName; } },
      { key: 'connector', kicker: this.config.i18n.summaryKickerConnector, item: this.state.connector, nameFn: function (i) { return i.title; } }
    ];

    var total = 0;
    var html = '';

    singleRows.forEach(function (row) {
      if (!row.item) return;
      var isFree = row.key === 'cord';
      if (!isFree) total += row.item.price;
      html += self.buildSummaryRowHtml(row.kicker, row.item, row.nameFn(row.item), row.key, isFree);
    });

    this.state.charm.forEach(function (item, i) {
      total += item.price;
      var kicker = self.state.charm.length > 1
        ? self.config.i18n.summaryKickerCharmNumbered.replace('%n%', i + 1)
        : self.config.i18n.summaryKickerCharm;
      html += self.buildSummaryRowHtml(kicker, item, item.title, 'charm');
    });

    html += '<div class="jb-summary__total"><span>' + this.config.i18n.summaryTotalLabel + '</span><strong>' + this.formatMoney(total) + '</strong></div>';

    this.el.summary.innerHTML = html;
  };

  /* -------------------- Ajout au panier -------------------- */

  JewelryBuilder.prototype.addToCart = function () {
    var self = this;

    var charmMissing = this.pressMode && this.state.charm.length === 0;
    if (!this.state.cord || !this.state.connector || charmMissing) {
      this.showToast(this.config.i18n.cartMissingSelection, true);
      return;
    }

    var i18n = this.config.i18n;
    var configurationId = 'CT-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();

    var cordProps = {
      [i18n.propCreation]: i18n.propCreationValue,
      [i18n.propCordType]: this.state.cord.productType,
      [i18n.propColor]: this.state.cord.colorName,
      [i18n.propConfigurationId]: configurationId,
      '_configuration_id': configurationId
    };
    var connectorProps = {
      [i18n.propCreation]: i18n.propCreationValue,
      [i18n.propConnector]: this.state.connector.title,
      [i18n.propConfigurationId]: configurationId,
      '_configuration_id': configurationId
    };
    if (this.pressMode) {
      cordProps[i18n.propPressCode] = this.pressCode;
      connectorProps[i18n.propPressCode] = this.pressCode;
    }

    var items = [
      { id: this.state.cord.variantId, quantity: 1, properties: cordProps },
      { id: this.state.connector.variantId, quantity: 1, properties: connectorProps }
    ];

    this.state.charm.forEach(function (charmItem) {
      var charmProps = {
        [i18n.propCreation]: i18n.propCreationValue,
        [i18n.propCharm]: charmItem.title,
        [i18n.propConfigurationId]: configurationId,
        '_configuration_id': configurationId
      };
      if (self.pressMode) {
        charmProps[i18n.propPressCode] = self.pressCode;
      }
      items.push({ id: charmItem.variantId, quantity: 1, properties: charmProps });
    });

    this.setButtonLoading(this.el.addToCartBtn, true);

    fetch(this.config.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || i18n.cartAddErrorFallback);
          });
        }
        return response.json();
      })
      .then(function () {
        if (self.pressMode) {
          // Redirige vers l'application automatique du code presse, puis le checkout.
          window.location.href = '/discount/' + encodeURIComponent(self.pressCode) + '?redirect=/checkout';
          return;
        }
        self.setButtonLoading(self.el.addToCartBtn, false);
        self.showToast(i18n.cartSuccess, false);
        self.notifyCartUpdate();
        self.resetConfiguration();
      })
      .catch(function (err) {
        self.setButtonLoading(self.el.addToCartBtn, false);
        var message = err && err.message ? err.message : i18n.cartGenericError;
        if (!navigator.onLine) {
          message = i18n.cartOfflineError;
        }
        self.showToast(message, true);
      });
  };

  JewelryBuilder.prototype.notifyCartUpdate = function () {
    // Événement officiel du thème Impulse (Archetype) pour forcer le
    // rafraîchissement complet du tiroir panier après un ajout hors du
    // formulaire natif du thème.
    // Source : https://help.archetypethemes.co/hc/en-us/articles/45871298573843
    document.dispatchEvent(new CustomEvent('cart:build'));
  };

  JewelryBuilder.prototype.resetConfiguration = function () {
    this.state = { cord: null, connector: null, charm: [] };
    this.currentStepIndex = 0;
    this.cordFilter = 'all';
    this.charmFilters = { search: '', finish: 'all' };
    if (this.el.charmSearch) this.el.charmSearch.value = '';
    this.el.cordTabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-cord-filter') === 'all' ? 'true' : 'false'); });
    this.el.charmFinishFilters.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-charm-finish') === 'all' ? 'true' : 'false'); });
    this.renderAllGrids();
    this.updateAllUI();
    try { sessionStorage.removeItem(this.storageKey()); } catch (e) { /* noop */ }
  };

  /* -------------------- Persistance sessionStorage -------------------- */

  JewelryBuilder.prototype.storageKey = function () {
    return STORAGE_KEY + '-' + this.root.getAttribute('data-section-id');
  };

  JewelryBuilder.prototype.persistToSession = function () {
    try {
      sessionStorage.setItem(this.storageKey(), JSON.stringify(this.state));
    } catch (e) { /* stockage indisponible, on ignore silencieusement */ }
  };

  JewelryBuilder.prototype.restoreFromSession = function () {
    try {
      var raw = sessionStorage.getItem(this.storageKey());
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          this.state.cord = parsed.cord || null;
          this.state.connector = parsed.connector || null;
          this.state.charm = Array.isArray(parsed.charm) ? parsed.charm : [];
        }
      }
    } catch (e) { /* ignore */ }
  };

  /* -------------------- Utilitaires -------------------- */

  JewelryBuilder.prototype.formatMoney = function (cents) {
    var format = this.config.moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;

      if (isNaN(number) || number === null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var wholePart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var decimalPart = parts[1] ? decimal + parts[1] : '';

      return wholePart + decimalPart;
    }

    var value = withDelimiters(cents, 2);

    if (match) {
      switch (match[1]) {
        case 'amount':
          value = withDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, '\'', '.');
          break;
      }
      return format.replace(placeholderRegex, value);
    }

    return value;
  };

  JewelryBuilder.prototype.escapeHtml = function (str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  };

  JewelryBuilder.prototype.announce = function (message) {
    if (this.el.announcer) this.el.announcer.textContent = message;
  };

  JewelryBuilder.prototype.setButtonLoading = function (btn, isLoading) {
    if (!btn) return;
    btn.disabled = isLoading;
    if (isLoading) {
      btn.setAttribute('data-loading', 'true');
    } else {
      btn.removeAttribute('data-loading');
    }
  };

  var toastTimer;
  JewelryBuilder.prototype.showToast = function (message, isError) {
    var toast = this.el.toast;
    if (!toast) return;
    toast.textContent = message;
    toast.className = 'jb-toast jb-toast--visible' + (isError ? ' jb-toast--error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.className = 'jb-toast';
    }, 4000);
  };

  /* -------------------- Bootstrap -------------------- */

  function ready() {
    var roots = document.querySelectorAll('[data-jewelry-builder]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();